"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
var _removeTags = require("../../../common/removeTags");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.page-accordion-generic-container {\n  width: 100%; }\n  .page-accordion-generic-container .bx--accordion__heading:focus::before {\n    border-width: 0px; }\n  .page-accordion-generic-container .bx--accordion__heading:hover::before {\n    opacity: 0.3; }\n  .page-accordion-generic-container .bx--accordion__title {\n    color: #e41b13;\n    font-family: 'Helvetica Neue LT Roman';\n    font-size: 16px;\n    margin: 0px; }\n  .page-accordion-generic-container .bx--accordion__content {\n    padding: 0px;\n    padding-top: 16px; }\n  .page-accordion-generic-container .accordion-content {\n    display: flex;\n    flex-direction: column; }\n";
  const fileName = "PageAccordionGeneric_PageAccordionGeneric";
  const element = document.querySelector("style[data-sass-component='PageAccordionGeneric_PageAccordionGeneric']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getId = el => {
  const content = Object.values(el?.col_0 || {});
  const title = el.accordion_generic_el_title ? (0, _removeTags.removeTags)(el.accordion_generic_el_title[0]) : '';
  const id = content[0]?.id || title;
  return id;
};
const PageAccordionGeneric = _ref => {
  let {
    item,
    Item,
    history,
    Content,
    ...rest
  } = _ref;
  const ref = (0, _react.useRef)(null);
  const location = history?.location;
  const elements = item.accordion_generic_element;
  const myParam = location?.search;
  const accordionItem = new URLSearchParams(myParam).get('item');
  const handleScroll = () => {
    const selectedItem = elements.find(el => {
      return accordionItem == getId(el);
    });
    if (selectedItem) {
      if (!ref?.current) return;
      const element = ref?.current;
      if (!element) return;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 75;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      handleScroll();
    }, 500);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-accordion-generic-container sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Accordion, null, elements.map((el, index) => {
    const content = Object.values(el?.col_0 || {});
    const title = el.accordion_generic_el_title ? el.accordion_generic_el_title[0] : '';
    const id = getId(el);
    const isSelected = id == accordionItem;
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.AccordionItem, {
      open: isSelected ? isSelected : undefined,
      key: index,
      title: title,
      onHeadingClick: data => {
        const search = data?.isOpen ? new URLSearchParams({
          item: id
        }).toString() : undefined;
        history?.replace({
          ...history.location,
          search
        });
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: isSelected ? ref : undefined
    }, Content ? /*#__PURE__*/_react.default.createElement(Content, _extends({
      content: content,
      element: el
    }, rest)) : content.map((contentElement, index) => {
      return /*#__PURE__*/_react.default.createElement(Item, _extends({
        key: index,
        item: contentElement
      }, el, rest));
    })));
  })));
};
PageAccordionGeneric.propTypes = {
  item: _propTypes.default.object.isRequired,
  history: _propTypes.default.object
};
var _default = exports.default = PageAccordionGeneric;